'use strict';

import { DnsResolver, DnsValidator } from './dnsUtils';

class EmailDomainValidation {
    run (elementName, errorElementName) {
        const _self = this;
        this.$element = $(elementName);
        this.$errorElement = $(errorElementName);
        this.$element.on('change', function () {
            _self.check();
        });
    }

    check () {
        let emailValue = this.$element.val();

        if (this.isValidEmail(emailValue)) {
            let domain = emailValue.split('@')[1];

            const _self = this;
            this.isValidDomain(domain).then((exists) => {
                _self.toggleErrorMessage(!exists);
            }).catch(() => {
                _self.toggleErrorMessage(false);
            });
        } else {
            this.toggleErrorMessage(false);
        }
    }

    isValidEmail (value) {
        const validEmailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        return validEmailRegex.test(value);
    }

    isValidDomain (value) {
        return new Promise((resolve, reject) => {
            DnsResolver.resolve('MX', value).then(response => {
                const validator = new DnsValidator(response);
                resolve(validator.isValidDomain());
            }).catch(err => reject(err));
        });
    }

    toggleErrorMessage (state) {
        this.$errorElement.toggleClass('is-visible', state);
    }
}

const emailDomainValidation = new EmailDomainValidation();
export default emailDomainValidation;
